export const ArrowUpIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99994 2.25C9.1073 2.25 9.20936 2.27284 9.3017 2.31348C9.36938 2.34321 9.43391 2.38289 9.49213 2.43359C9.50665 2.44623 9.52062 2.45993 9.53412 2.47363L13.2802 6.21973C13.5731 6.51262 13.5731 6.98738 13.2802 7.28027C12.9873 7.57315 12.5126 7.57315 12.2197 7.28027L9.74994 4.81055V15C9.74994 15.4142 9.41416 15.75 8.99994 15.75C8.58573 15.75 8.24994 15.4142 8.24994 15V4.81055L5.78022 7.28027C5.48732 7.57317 5.01256 7.57316 4.71967 7.28027C4.42678 6.98738 4.42678 6.51262 4.71967 6.21973L8.46967 2.46973C8.54501 2.39439 8.6323 2.33834 8.72553 2.30176C8.81051 2.26833 8.90309 2.25 8.99994 2.25Z"
      fill="currentColor"
    />
  </svg>
);
